import { useState } from "react";
import { copy } from "../copy";
import Icon from "../components/Icon";
import { signInWithGoogle } from "./google";

// Continue with Google, then a full page load of `next`. A closed popup or
// a server refusal shows one generic message.
export default function GoogleButton({ onDone, onError }: { onDone: () => void; onError: (message: string) => void }) {
  const [busy, setBusy] = useState(false);
  const start = async () => {
    setBusy(true);
    try {
      await signInWithGoogle();
      onDone();
    } catch {
      onError(copy.auth.googleFailed);
      setBusy(false);
    }
  };
  return (
    <>
      <button
        type="button"
        onClick={start}
        disabled={busy}
        className="bf-focusable flex h-12 w-full items-center justify-center gap-3 rounded-md border border-ground-edge bg-ground-raised text-sm font-bold text-chrome transition-colors hover:border-chrome-dim/60 disabled:opacity-60"
      >
        <Icon name="google" className="text-lg" />
        {copy.auth.google}
      </button>
      <div className="my-6 flex items-center gap-4" aria-hidden>
        <span className="h-px flex-1 bg-ground-edge" />
        <span className="text-[10px] uppercase tracking-[0.2em] text-chrome-dim">{copy.auth.or}</span>
        <span className="h-px flex-1 bg-ground-edge" />
      </div>
    </>
  );
}
